import {
  MockCard,
  MockInput,
  MockSelect,
  MockButton,
  MockSearchInput,
  MockLink,
  MockWarning,
} from '../../components/mockups/MockUI'
import { MockCategoryBadge } from '../../components/mockups/MockBadge'
import { MockTable } from '../../components/mockups/MockTable'

export function ClientsList() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Список клиентов
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Страница «Клиенты» — список всех ваших клиентов. ADMIN видит клиентов всех менеджеров,
          MANAGER — только своих. Доступна через пункт «Клиенты» в боковом меню (иконка двух людей).
        </p>
      </div>

      <MockCard>
        <div className="flex items-center justify-between mb-4">
          <span className="text-lg font-semibold text-gray-900 dark:text-gray-100">Клиенты</span>
          <MockButton>+ Новый клиент</MockButton>
        </div>
        <div className="flex items-center gap-2 mb-4">
          <MockSearchInput placeholder="Поиск по названию, коду, ИНН..." />
          <MockSelect label="" value="Все категории" />
        </div>
      </MockCard>

      <MockTable
        caption="Пример таблицы клиентов"
        columns={[
          { header: 'Название' },
          { header: 'Код' },
          { header: 'ИНН' },
          { header: 'Город' },
          { header: 'Категория' },
          { header: 'Заявок' },
        ]}
        rows={[
          [
            <MockLink>ООО «Электросервис»</MockLink>,
            'Э001',
            '7712345678',
            'Москва',
            <MockCategoryBadge cat="A" />,
            '12',
          ],
          [
            <MockLink>АО «ТехноПром»</MockLink>,
            'Т002',
            '7898765432',
            'Санкт-Петербург',
            <MockCategoryBadge cat="B" />,
            '5',
          ],
          [
            <MockLink>ИП Сидоров</MockLink>,
            'С003',
            '—',
            'Казань',
            <MockCategoryBadge cat="C" />,
            '2',
          ],
        ]}
      />

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Категории клиентов:</div>
          <ul className="space-y-1 list-none">
            <li>
              <MockCategoryBadge cat="A" />{' '}
              <span className="ml-1">— Ключевой заказчик. Крупные объёмы, постоянные заказы.</span>
            </li>
            <li>
              <MockCategoryBadge cat="B" />{' '}
              <span className="ml-1">— Средний заказчик. Регулярные, но меньшие объёмы.</span>
            </li>
            <li>
              <MockCategoryBadge cat="C" />{' '}
              <span className="ml-1">— Мелкий или разовый заказчик.</span>
            </li>
          </ul>
        </div>
      </MockCard>

      <p className="text-sm text-gray-600 dark:text-gray-400">
        Клик по названию клиента открывает его карточку. Поиск работает по названию, коду и ИНН
        одновременно. Фильтр по категории позволяет быстро найти ключевых клиентов.
      </p>
    </div>
  )
}

export function ClientsNew() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Создание клиента
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Кнопка «+ Новый клиент» на странице списка клиентов. Открывает форму создания нового
          клиента.
        </p>
      </div>

      <MockCard className="max-w-lg">
        <div className="text-base font-medium text-gray-900 dark:text-gray-100 mb-4">
          Новый клиент
        </div>
        <div className="space-y-3">
          <MockInput label="Название *" value="ООО «НовыйКлиент»" />
          <MockInput label="Код" value="Н004" />
          <MockInput label="ИНН" value="7700123456" />
          <MockSelect label="Категория *" value="B — Средний заказчик" />
          <MockInput label="Город" value="Москва" />
          <MockSelect label="Сегмент" value="Промэлектроника" />
          <MockInput label="Заметки" placeholder="Дополнительная информация о клиенте..." />
          <div className="flex gap-2 pt-2">
            <MockButton>Создать</MockButton>
            <MockButton variant="secondary">Отмена</MockButton>
          </div>
        </div>
      </MockCard>

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Обязательные поля:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              <span className="font-medium">Название</span> — полное название организации или ИП
            </li>
            <li>
              <span className="font-medium">Категория</span> — A, B или C
            </li>
          </ul>
          <div className="font-medium text-gray-800 dark:text-gray-200 mt-3">
            Необязательные поля:
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              <span className="font-medium">Код</span> — внутренний короткий код для быстрого поиска
            </li>
            <li>
              <span className="font-medium">ИНН</span> — проверяется на дубликаты (см. раздел
              «Проверка ИНН»)
            </li>
            <li>
              <span className="font-medium">Город</span> — автокоррекция (СПБ → Санкт-Петербург, МСК
              → Москва)
            </li>
            <li>
              <span className="font-medium">Сегмент</span> — ВПК, СБ, Промэлектроника, IT, Связь,
              Медицина, Другое
            </li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function ClientsDetail() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Карточка клиента
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Открывается при клике на название клиента в списке. Содержит всю информацию о клиенте,
          метрики и список его заявок.
        </p>
      </div>

      <MockCard>
        <div className="flex items-center justify-between mb-4">
          <div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              ← Клиенты / ООО «Электросервис»
            </div>
            <div className="text-lg font-semibold text-gray-900 dark:text-gray-100 mt-1">
              ООО «Электросервис»
            </div>
          </div>
          <div className="flex gap-2">
            <MockButton variant="secondary">Редактировать</MockButton>
            <MockButton variant="danger">Удалить</MockButton>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm">
          <div>
            <span className="text-gray-500 dark:text-gray-400">Код:</span>{' '}
            <span className="font-medium text-gray-800 dark:text-gray-200">Э001</span>
          </div>
          <div>
            <span className="text-gray-500 dark:text-gray-400">ИНН:</span>{' '}
            <span className="font-medium text-gray-800 dark:text-gray-200">7712345678</span>
          </div>
          <div>
            <span className="text-gray-500 dark:text-gray-400">Категория:</span>{' '}
            <MockCategoryBadge cat="A" />
          </div>
          <div>
            <span className="text-gray-500 dark:text-gray-400">Город:</span>{' '}
            <span className="font-medium text-gray-800 dark:text-gray-200">Москва</span>
          </div>
          <div>
            <span className="text-gray-500 dark:text-gray-400">Сегмент:</span>{' '}
            <span className="font-medium text-gray-800 dark:text-gray-200">Промэлектроника</span>
          </div>
        </div>
      </MockCard>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <MockCard className="text-center">
          <div className="text-2xl font-bold text-gray-900 dark:text-gray-100">12</div>
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">Всего заявок</div>
        </MockCard>
        <MockCard className="text-center">
          <div className="text-2xl font-bold text-teal-600">5</div>
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">КП отправлено</div>
        </MockCard>
        <MockCard className="text-center">
          <div className="text-2xl font-bold text-green-600">3</div>
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">Оплачено (сделки)</div>
        </MockCard>
        <MockCard className="text-center">
          <div className="text-2xl font-bold text-blue-600">485 000 ₽</div>
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">Сумма КП</div>
        </MockCard>
      </div>

      <p className="text-sm text-gray-600 dark:text-gray-400">
        Ниже метрик расположена таблица заявок этого клиента — такая же, как на странице «Заявки»,
        но отфильтрованная по этому клиенту. Можно перейти в любую заявку кликом.
      </p>
    </div>
  )
}

export function ClientsInn() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Проверка ИНН
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          При вводе ИНН в форме создания клиента система автоматически проверяет, нет ли клиента с
          таким же ИНН у другого менеджера. Проверка срабатывает через 0.5 секунды после ввода.
        </p>
      </div>

      <MockCard className="max-w-lg">
        <div className="space-y-3">
          <MockInput label="ИНН" value="7712345678" />
          <MockWarning>
            <div className="flex items-start gap-2">
              <span className="text-amber-500 text-sm">⚠️</span>
              <div>
                <div className="font-medium">Клиент с таким ИНН уже существует</div>
                <div className="mt-1">
                  <MockLink>ООО «Электросервис»</MockLink>
                  <span className="ml-1 text-gray-500">— менеджер: Петров И.</span>
                </div>
              </div>
            </div>
          </MockWarning>
        </div>
      </MockCard>

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Что это значит:</div>
          <p>
            Предупреждение появляется, если другой менеджер уже работает с клиентом с таким ИНН. Это
            помогает избежать дублирования клиентов в системе.
          </p>
          <p className="font-medium mt-2">
            Предупреждение НЕ блокирует создание — вы можете создать клиента, но рекомендуется
            уточнить ситуацию с коллегой.
          </p>
        </div>
      </MockCard>

      <p className="text-sm text-gray-600 dark:text-gray-400">
        Аналогичная проверка работает для поля «Код» — если код уже занят, появится предупреждение с
        ссылкой на существующего клиента.
      </p>
    </div>
  )
}
